export default __webpack_public_path__ + "static/media/Detalhe-Musical.0e15652b.jpg";